/** JS VARIABLES
 * colors */
export const primary01 = "var(--primary-01)";
export const primary02 = "var(--primary-02)";
export const primary03 = "var(--primary-03)";
export const shade0 = "var(--shade-0)";
export const shade50 = "var(--shade-50)";
export const shade100 = "var(--shade-100)";
export const shade200 = "var(--shade-200)";
export const shade300 = "var(--shade-300)";
export const shade400 = "var(--shade-400)";
export const shade500 = "var(--shade-500)";
export const shade600 = "var(--shade-600)";
export const shade700 = "var(--shade-700)";
export const shade800 = "var(--shade-800)";
export const shade850 = "var(--shade-850)";
export const shade900 = "var(--shade-900)";
export const shade950 = "var(--shade-950)";
export const shade1000 = "var(--shade-1000)";
export const semanticGreen = "var(--semantic-green)";
export const semanticAmber = "var(--semantic-amber)";
export const semanticRed01 = "var(--semantic-red-01)";
export const semanticRed02 = "var(--semantic-red-02)";
export const semanticBlue = "var(--semantic-blue)";
export const teal01 = "var(--teal-01)";
export const teal02 = "var(--teal-02)";
export const pink01 = "var(--pink-01)";
export const pink02 = "var(--pink-02)";
export const indigo01 = "var(--indigo-01)";
export const indigo02 = "var(--indigo-02)";
export const yellow01 = "var(--yellow-01)";
export const yellow02 = "var(--yellow-02)";
export const purple01 = "var(--purple-01)";
export const purple02 = "var(--purple-02)";
export const coral01 = "var(--coral-01)";
export const coral02 = "var(--coral-02)";

export const colorTokens = {
  primary01,
  primary02,
  primary03,
  shade0,
  shade50,
  shade100,
  shade200,
  shade300,
  shade400,
  shade500,
  shade600,
  shade700,
  shade800,
  shade850,
  shade900,
  shade950,
  shade1000,
  semanticGreen,
  semanticAmber,
  semanticRed01,
  semanticRed02,
  semanticBlue,
  teal01,
  teal02,
  pink01,
  pink02,
  indigo01,
  indigo02,
  yellow01,
  yellow02,
  purple01,
  purple02,
  coral01,
  coral02,
} as const;
export type ColorToken = keyof typeof colorTokens;

/** breakpoints
 * @todo Current values are from outdated comp library.
 * These need to be updated once design team has decided
 * on new breakpoint values */
export const maxXSmall = "(max-width: 600px)";
export const minSmall = "(min-width: 601px)";
export const maxSmall = "(max-width: 743px)";
export const minMedium = "(min-width: 744px)";
export const maxMedium = "(max-width: 1280px)";
export const minLarge = "(min-width: 1281px)";
export const maxLarge = "(max-width: 1600px)";
export const minXLarge = "(min-width: 1601px)";
/** elevation */
export const elevation00 = "var(--elevation-00)";
export const elevation01 = "var(--elevation-01)";
export const elevation02 = "var(--elevation-02)";
export const elevation03 = "var(--elevation-03)";
export const elevation04 = "var(--elevation-04)";
/** opacity */
export const opacity00 = "var(--opacity-00)";

/** CSS VARIABLES */
export const colors = {
  dark: {
    "--primary-01": "#ff4e00",
    "--primary-02": "#cc3e00",
    "--primary-03": "#ff6b2a",
    "--shade-0": "#FFFFFF",
    "--shade-06": "#222",
    "--shade-50": "#F6F6F6",
    "--shade-100": "#EBEBEB",
    "--shade-200": "#D7D7D7",
    "--shade-300": "#CCCCCC",
    "--shade-400": "#B0B0B0",
    "--shade-500": "#A6A6A6",
    "--shade-600": "#6C6C6C",
    "--shade-700": "#555555",
    "--shade-800": "#2E2E2E",
    "--shade-850": "#232323",
    "--shade-900": "#1A1A1A",
    "--shade-950": "#121212",
    "--shade-1000": "#000000",
    "--semantic-green": "#20C885",
    "--semantic-amber": "#F88600",
    "--semantic-red-01": "#F12121",
    "--semantic-red-02": "#E04A4A",
    "--semantic-blue": "#CBE4EC",
    "--teal-01": "#2FA4A9",
    "--teal-02": "#4BBEC3",
    "--pink-01": "#D96B8A",
    "--pink-02": "#E1849E",
    "--indigo-01": "#5B6C9D",
    "--indigo-02": "#7486B8",
    "--yellow-01": "#E6A23C",
    "--yellow-02": "#FFC15A",
    "--purple-01": "#8A5E8F",
    "--purple-02": "#93629B",
    "--coral-01": "#FF8A5B",
    "--coral-02": "#FFA07A",
    "--elevation-00": "0px 4px 8px 0px rgba(18, 18, 18, 0.5)",
    "--elevation-01": "0px 16px 32px 0px rgba(0, 0, 0, 1)",
    "--elevation-02": "0px 24px 48px 0px rgba(0, 0, 0, 1)",
    "--elevation-03": "0px 32px 64px 8px rgba(0, 0, 0, 1)",
    "--elevation-04": "0px 32px 96px 24px rgba(0, 0, 0, 1)",
    "--opacity-00": "#00000080",
  },
  /** @todo light mode colors have not been determined yet by the design team */
  light: {
    "--primary-01": "#ff4e00",
    "--primary-02": "#cc3e00",
    "--primary-03": "#ff6b2a",
    "--shade-0": "#FFFFFF",
    "--shade-50": "#F6F6F6",
    "--shade-100": "#EBEBEB",
    "--shade-200": "#D7D7D7",
    "--shade-300": "#CCCCCC",
    "--shade-400": "#B0B0B0",
    "--shade-500": "#A6A6A6",
    "--shade-600": "#6C6C6C",
    "--shade-700": "#555555",
    "--shade-800": "#2E2E2E",
    "--shade-850": "#232323",
    "--shade-900": "#1A1A1A",
    "--shade-950": "#121212",
    "--shade-1000": "#000000",
    "--semantic-green": "#20C885",
    "--semantic-amber": "#F88600",
    "--semantic-red-01": "#F12121",
    "--semantic-red-02": "#E04A4A",
    "--semantic-blue": "#CBE4EC",
    "--elevation-00": "0px 4px 8px 0px rgba(18, 18, 18, 0.5)",
    "--elevation-01": "0px 16px 32px 0px rgba(0, 0, 0, 1)",
    "--elevation-02": "0px 24px 48px 0px rgba(0, 0, 0, 1)",
    "--elevation-03": "0px 32px 64px 8px rgba(0, 0, 0, 1)",
    "--elevation-04": "0px 32px 96px 24px rgba(0, 0, 0, 1)",
    "--opacity-00": "#00000080",
  },
};
